import { UtilService } from 'src/app/core/services/util/util.service';
import { Injectable, OnDestroy, inject, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { I18nService } from 'src/app/core/services/i18n/i18n.service';
import { BrowserPlatformService } from 'src/app/core/services/browser-platform/browser-platform.service';

@Injectable({
    providedIn: 'root',
})
export class SocialShareService implements OnDestroy {
    _i18n = inject(I18nService);
    private _router = inject(Router);
    private _utils = inject(UtilService);
    private _browser = inject(BrowserPlatformService);

    constructor() {
        const _i18n = this._i18n;
        const _router = this._router;

        this.isSocialShareBoxOpenSub = new BehaviorSubject<boolean>(false);
        this._fullUrlWithOutParamSub = new Subject<string>();
        this._subscriptions.push(
            _router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
                this.setFullUrlWithOutParam(_i18n.getLangBaseUrl() + event.url.split('?')[0].split('#')[0]);
            }),
        );
        this._subscriptions.push(
            this.getFullUrlWithOutParam().subscribe((FullUrlWithOutParam: string) => {
                this.fullUrlWithOutParam = FullUrlWithOutParam;
            }),
        );
    }

    private _subscriptions: Subscription[] = [];

    ngOnDestroy(): void {
        this._utils.unsubscribe(this._subscriptions);
        if (this.isSocialShareBoxOpenSub) {
            this.isSocialShareBoxOpenSub.unsubscribe();
        }
        if (this._fullUrlWithOutParamSub) {
            this._fullUrlWithOutParamSub.unsubscribe();
        }
    }

    private _fullUrlWithOutParamSub: Subject<string>;
    public getFullUrlWithOutParam(): Observable<string> {
        return this._fullUrlWithOutParamSub.asObservable();
    }
    public setFullUrlWithOutParam(fullUrlWithOutParam: string): void {
        this._fullUrlWithOutParamSub.next(fullUrlWithOutParam);
    }

    private isSocialShareBoxOpenSub: BehaviorSubject<boolean>;
    public getIsSocialShareBox(): Observable<boolean> {
        return this.isSocialShareBoxOpenSub.asObservable();
    }
    public setIsSocialShareBox(isSocialShareBoxOpen: boolean): void {
        this.isSocialShareBoxOpenSub.next(isSocialShareBoxOpen);
    }

    // Signal-backed so OnPush templates reading it directly are tracked; the property syntax stays unchanged.
    private readonly _fullUrlWithOutParam = signal('');
    public get fullUrlWithOutParam(): string {
        return this._fullUrlWithOutParam();
    }
    public set fullUrlWithOutParam(fullUrlWithOutParam: string) {
        this._fullUrlWithOutParam.set(fullUrlWithOutParam);
    }
    public prefixMsg: string = $localize`:@@NowInYeshiva:עכשיו באתר ישיבה`;
    public suffixMsg = $localize`:@@WhyInternet:בשביל זה יש אינטרנט`;
    public getFullUrlWithoutQueryParam() {
        return this._i18n.getLangBaseUrl() + (this._browser.location?.pathname ?? '');
    }

    public toggleSocialShareBox(isSocialShareBoxOpen: boolean) {
        this.isSocialShareBoxOpenSub.next(isSocialShareBoxOpen);
    }
}
